module.exports = __webpack_public_path__ + "static/favicon-bbdc6dfec59ff4d77c7fba8ff1ac2de3.ico";